"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Judge = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var agreement_1 = require("../../model/agreement");
var service_1 = require("../../../library/base/service");
var Judge = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Judge, _super);
    function Judge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '协议更新判断接口';
        _this.code = '100007';
        _this.desc = '协议更新判断接口';
        _this.requestParams = new agreement_1.JudgeRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Judge;
}(service_1.BaseService));
exports.Judge = Judge;
//# sourceMappingURL=judge.js.map